import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import herroPic from "../../assets/herroPic.png";
import Home1 from "../../assets/home1.png";
import WaveWithLetters from "../../assets/Wavebluewithletters.png";
import WaveWithLettersMedium from "../../assets/WaveWithLettersMedium.png";
import WaveWithLettersSmall from "../../assets/waveblueLettersSmall.png";
import Home2 from "../../assets/home2.png";
import Home3 from "../../assets/home3.png";
import Home4 from "../../assets/home4.png";
import Feedback from "./components/Feedback/Feedback";
import Carousel from "../Carousel";
import SpeechBubble from "./components/SpeechBubble/SpeechBubble";

import "./Home.scss";
import useNavigation from "../../hooks/useNavigation";
import useWindowWidth from "../../hooks/useWindowWidth";
import useAffiliateCodeModal from "../../hooks/useAffiliateCodeModal";
import { AffiliateCodeModal, ChoosePlanFirstModal } from "../../modals";
import { isAccessFeature } from "../../common/utils";
import WelcomeModal from "./components/WelcomeModal";

const Home = () => {
  const { isAuth, user, error } = useNavigation();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (
      !localStorage.isFirstSeen &&
      !localStorage.CAREER_SCOOPS_AUTH_ACCESS?.length
    ) {
      setIsOpen(true);
    }
  }, []);
  const {
    affiliateCodeModal,
    choosePlanFirstOpen,
    closeAffiliateCodeModal,
    closeChoosePlanFirstModal,
    confirmAffiliateCodeSuccess,
    confirmChoosePlanFirstModal,
    openAffiliateCodeModal,
    setAffiliateCode,
    submitAffiliateCode,
  } = useAffiliateCodeModal(user);
  const isErrorPricing = isAccessFeature(user);

  const handleLetsStart = () => {
    if (isAuth) {
      if (!isErrorPricing.plan_active) {
        openAffiliateCodeModal();
      } else {
        navigate("/scenario/0");
      }
    } else {
      navigate("/signin");
    }
  };
  const { width } = useWindowWidth();

  const armanFirstSpeechText = (
    <>
      Hi, I'm <span>Arman</span>. Like many young people today, I grew up
      searching for direction in a world full of choices and uncertainty. I
      wanted a future with purpose, but finding my path wasn’t always clear.
      When I realized how many others felt the same way, Career Scoops began to
      take shape.
    </>
  );

  const armanSecondSpeechText = `The challenge is real. Many young people feel uncertain about what comes next. Whether it’s choosing college, exploring alternatives, or navigating life after graduation, the options can feel overwhelming. Career Scoops is here to turn confusion into clarity and confidence.`;

  const armanThirdSpeechText = `Career Scoops isn’t about having all the answers. It’s about understanding yourself and exploring what fits. Uncover strengths, see real possibilities, and move forward with intention.`;

  const armanFourthSpeechText = `Passionate about mentoring? Join a community of professionals guiding young people through real-world insight and experience.`;

  const handleWelcomeModal = () => {
    localStorage.isFirstSeen = true;
    setIsOpen(!isOpen);
  };
  return (
    <section className="Home">
      <div className="Home-welcome">
        <div className="Home-welcome-content">
          <div className="Home-welcome-content-text">
            <div className="Home-welcome-content-text__title">
              <h1>
                Discover Your Strengths and Build<span>Your Future</span>
              </h1>
            </div>
            <p>
              The world is changing fast, and success looks different for
              everyone. Career Scoops helps you explore your strengths,
              understand what’s possible, and move forward with clarity and
              confidence that grow with you.
            </p>
            {user?.role === "Mentor" ? (
              <></>
            ) : (
              <button onClick={handleLetsStart}>Let's Start</button>
            )}
          </div>
          <div className="Home-welcome-content__img">
            <img src={herroPic} alt="" />
            <p>
              Are you here to <span>EXPLORE ?</span>
            </p>
          </div>
        </div>
      </div>
      <img
        src={
          width <= 600
            ? WaveWithLettersSmall
            : width <= 991
              ? WaveWithLettersMedium
              : WaveWithLetters
        }
        alt="WaveWithLetters"
        className="waveimg"
      />
      <div className="Home-content">
        <h3>Our Story</h3>
        <div className="Home-content-items">
          <div className="item">
            <img src={Home1} alt="" />
            <SpeechBubble
              altText="armanFirstSpeechText"
              speechText={armanFirstSpeechText}
            />
          </div>
          <div className="item">
            <img src={Home2} alt="" />
            <SpeechBubble
              altText="armanSecondSpeechText"
              speechText={armanSecondSpeechText}
            />
          </div>
          <div className="item">
            <img src={Home3} alt="" />
            <SpeechBubble
              altText="armanThirdSpeechText"
              buttonLink="/new/student/"
              buttonText="Career Explorer Sign Up"
              floatSide="right"
              hasButton
              speechText={armanThirdSpeechText}
            />
          </div>
          <div className="item">
            <img src={Home4} alt="" />
            <SpeechBubble
              altText="armanFourthSpeechText"
              buttonLink="/signup/mentor"
              buttonText="Community Partner Sign Up"
              floatSide="left"
              hasButton
              speechText={armanFourthSpeechText}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "100px 0 0 0",
          }}
        >
          <p style={{ width: "656px", fontSize: "36px", color: "#174273" }}>
            Discover your match among{" "}
            <span style={{ fontWeight: "700", fontSize: "48px" }}>800+</span>{" "}
            career options tailored just for you
          </p>
        </div>
        <Carousel />
      </div>
      <ChoosePlanFirstModal
        isOpened={choosePlanFirstOpen}
        onClose={closeChoosePlanFirstModal}
        onContinue={confirmChoosePlanFirstModal}
      />
      <AffiliateCodeModal
        {...affiliateCodeModal}
        onBack={closeAffiliateCodeModal}
        onChange={setAffiliateCode}
        onClose={closeAffiliateCodeModal}
        onPricingPlanClick={() => {
          closeAffiliateCodeModal();
          navigate(isErrorPricing.code_active ? "/scenario/0" : "/pricingplan");
        }}
        onSubmit={submitAffiliateCode}
        onSuccessClose={confirmAffiliateCodeSuccess}
      />
      <Feedback />
      <WelcomeModal
        title={"WELCOME"}
        text={"Choose your path to get started"}
        isOpened={isOpen}
        // removeChanges={handleConfirm}
        leftBtnText="Student"
        rightBtnText="Educator/Partner"
        handleStayPage={handleWelcomeModal}
        handleEducation={() =>
          window.open("https://careerscoops.ai/", "_blank")
        }
        close={handleWelcomeModal}
      />
    </section>
  );
};

export default Home;
